/* eslint-disable no-console */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-negated-condition */
import { css } from "@emotion/react";
import { useCallback, useEffect, useRef, useState } from "react";
import {
  AttachmentBlack,
  Send,
  Smile,
  CannedMessageIcon,
  spaikIcon
} from "../../assets";
import { AudioRecorder } from "./AudioRecorder";
import { iDialogMessagesFile } from "../use-omnichannel";
import { AuthContextType, useAuth } from "../../auth/auth-provider";
import {
  Button,
  CannedMessageAutocomplete,
  CannedMessageAutocompleteItem,
  CannedMessageRightModalContent,
  ContainerLeftModal,
  ContainerRightModal,
  ImgIcon,
  QuoteMessage
} from "./styles";
import { Tooltip } from "primereact/tooltip";
import OmnichannelService from "../../services/omnichannelService";
import { useToast } from "../../components";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import { useAppSelector, useAppDispatch } from "../../redux/hooks";
import {
  setContactId,
  setShowModalContacts,
  setNameContact,
  setReplyMessage,
  setIsUploadingFile
} from "../../redux/slices/omnichannel";
import DialogPadrao from "../../components/DialogPadrao";
import {
  setEmojiModalOpen,
  setEmojiTarget,
  textEmoji
} from "../../redux/slices/flowInteractions";
import { EmojiModal } from "../../components/Interactions/components/interacaoRobo/EmojiModal";
import { iFile } from "../use-omnichannel";
import { AudioPlayer } from "./AudioPreview";
import { VideoPreview } from "./VideoPreview";
import { CannedMessage } from "../../components/CannedMessage";
import useCannedMessageShortcut from "./use-cannedMessage-shortcut";
import {
  AttachmentUploadProgress,
  buildComposerAttachments,
  ComposerAttachment,
  ComposerAttachmentsPreview,
  createFileListFromFiles,
  revokeComposerAttachments,
  validateComposerFiles
} from "./composer-attachments";
import {
  createThrottledProgressReporter,
  uploadFileChunked
} from "./chunked-upload";
import {
  OMNICHANNEL_COMPOSER_FILES_EVENT,
  OmnichannelComposerFilesEventDetail
} from "./composer-file-events";

export interface InputProps {
  onSendMessage: (payload: {
    message: string;
    cannedMessageId?: number;
    quotedMessageId?: number;
    quotedMessage?: {
      parentId: number;
      message: string;
      mime?: string;
    };
  }) => Promise<void> | void;
  onFilesAttached: (files: FileList, message?: string) => Promise<void> | void;
  dialog: iDialogMessagesFile;
  botSelected: number | null;
  fileUploadProgress?: AttachmentUploadProgress | null;
  onDialogChange: (id: number) => Promise<void>;
  onDialogRefresh?: () => Promise<void>;
  startDialogFromContact: (payload: any) => Promise<any>;
}

interface AttachFilesProps {
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
}

const MIN_TEXTAREA_HEIGHT = 28;

const AttachFiles = ({ onChange, disabled = false }: AttachFilesProps) => {
  const inputFileRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <img
        src={AttachmentBlack}
        css={css`
          width: 18px;
          cursor: ${disabled ? "not-allowed" : "pointer"};
          opacity: ${disabled ? 0.5 : 1};
        `}
        onClick={() => {
          if (disabled) return;
          inputFileRef.current?.click();
        }}
      />
      <input
        type="file"
        multiple={true}
        ref={inputFileRef}
        css={css`
          display: none;
        `}
        disabled={disabled}
        onChange={onChange}
      />
    </>
  );
};

const FileImagePreview = ({ file }: { file: iFile }) => {
  const mime = file?.mime ?? "";
  if (!mime.startsWith("image/") || !file?.url) return null;

  return (
    <img
      src={file.url}
      height={60}
      style={{ maxWidth: "120px", objectFit: "cover", borderRadius: 6 }}
    />
  );
};

const FileLinkURL = ({
  filename,
  file
}: {
  filename: string;
  file?: iFile;
}) => {
  return (
    <a href={file?.url} target="_blank" rel="noreferrer">
      {filename}
    </a>
  );
};

const Input = ({
  onSendMessage,
  onFilesAttached,
  dialog,
  botSelected,
  fileUploadProgress,
  onDialogChange,
  onDialogRefresh,
  startDialogFromContact
}: InputProps) => {
  const { findDialogHistoryData } = OmnichannelService();
  const redirect = useNavigate();
  const [message, setMessage] = useState<string>("");
  const messageRef = useRef<HTMLTextAreaElement>(null);
  const [concatenatedAudioBlob, setConcatenatedAudioBlob] = useState<
    Blob | MediaSource | undefined
  >(undefined);
  const [contactFileUploadProgress, setContactFileUploadProgress] =
    useState<AttachmentUploadProgress | null>(null);
  const activeFileUploadProgress = fileUploadProgress ?? contactFileUploadProgress;
  const isUploadingFile =
    activeFileUploadProgress !== null && activeFileUploadProgress !== undefined;
  const [pendingAttachments, setPendingAttachments] = useState<
    ComposerAttachment[]
  >([]);
  const pendingAttachmentsRef = useRef<ComposerAttachment[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);
  const { joinDialog, joinQueueDialog, openDialog } = OmnichannelService();
  const toast = useToast();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setIsUploadingFile(isUploadingFile));

    if (!isUploadingFile) return undefined;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [dispatch, isUploadingFile]);

  useEffect(
    () => () => {
      dispatch(setIsUploadingFile(false));
    },
    [dispatch]
  );

  const [showDisableButton, setShowDisableButton] = useState(
    dialog.transferred
  );
  const [showInput, setShowInput] = useState("");
  const [valueDialog, setValueDialog] = useState<iDialogMessagesFile>();
  const user = useAuth() as AuthContextType;
  const location = useLocation();
  const newValueDialogId = useAppSelector(
    (state) => state.flowInteractions.newValueDialogId
  );
  const updateShowInput = useAppSelector(
    (state) => state.sidebar.updateShowInput
  );
  const emoji = useAppSelector(
    (state) => state.flowInteractions.valueTextEmoji
  );
  const emojiTarget = useAppSelector(
    (state) => state.flowInteractions.emojiTarget
  );
  const replyMessage = useAppSelector(
    (state) => state.omnichannel.replyMessage
  );
  const modalEdit = useAppSelector((state) => state.omnichannel.modalEdit);
  const [cursorPosition, setCursorPosition] = useState<number>(0);
  const contactId = useAppSelector((state) => state.omnichannel.contactId);
  const focusMessageInput = useCallback(() => {
    window.setTimeout(() => {
      messageRef.current?.focus();
    }, 0);
  }, []);
  const resetTextareaHeight = useCallback(() => {
    if (messageRef.current) {
      messageRef.current.style.height = `${MIN_TEXTAREA_HEIGHT}px`;
    }
  }, []);

  const setComposerSubmitting = useCallback((value: boolean) => {
    isSubmittingRef.current = value;
    setIsSubmitting(value);
  }, []);

  const withComposerSubmission = useCallback(
    async (callback: () => Promise<void>) => {
      if (isSubmittingRef.current) return;

      setComposerSubmitting(true);

      try {
        await callback();
      } finally {
        setComposerSubmitting(false);
      }
    },
    [setComposerSubmitting]
  );

  useEffect(() => {
    pendingAttachmentsRef.current = pendingAttachments;
  }, [pendingAttachments]);

  useEffect(
    () => () => {
      revokeComposerAttachments(pendingAttachmentsRef.current);
    },
    []
  );

  const setChatInputMessage = (value: string) => {
    setMessage(value);

    window.setTimeout(() => {
      if (messageRef.current) {
        messageRef.current.style.height = `${MIN_TEXTAREA_HEIGHT}px`;
        messageRef.current.style.height = `${messageRef.current.scrollHeight}px`;
      }
    }, 0);
  };
  const {
    showCannedMessageModal,
    setShowCannedMessageModal,
    cannedMessages,
    shortcutSuggestions,
    shortcutSuggestionsHasMore,
    shortcutSuggestionsLoading,
    selectedShortcutSuggestionIndex,
    cannedMessagesSearch,
    setCannedMessagesSearch,
    cannedMessagesHasMore,
    cannedMessagesLoading,
    cannedMessageMode,
    setCannedMessageMode,
    hasShortcutTrigger,
    applyCannedMessageShortcut,
    handleShortcutSuggestionsKeyDown,
    loadMoreShortcutSuggestions,
    loadMoreCannedMessages,
    handleShortcutSuggestionMouseEnter,
    setShortcutSuggestionItemRef,
    handleCreateSuccess,
    handleUpdateSuccess,
    handleDeleteSuccess,
    shortcutSuggestionsListRef,
    selectedCannedMessageId
  } = useCannedMessageShortcut({
    enabled: showInput === "input" || showInput === "joinContact",
    message,
    setMessage: setChatInputMessage,
    messageRef
  });

  const canSendOnOpenDialog = useCallback(() => {
    if (dialog.whatsappQrCode && dialog.qrCodeConnected === false) {
      toast.current?.show({
        life: 5000,
        severity: "warn",
        summary: "Aviso",
        detail:
          "O robô não está conectado. Por favor, conecte o robô para enviar mensagens"
      });
      return false;
    }

    return true;
  }, [dialog.qrCodeConnected, dialog.whatsappQrCode, toast]);

  const sendTextMessage = useCallback(
    async (text: string) => {
      await Promise.resolve(
        onSendMessage({
          message: text,
          cannedMessageId: selectedCannedMessageId,
          quotedMessageId: replyMessage ? replyMessage.id : undefined,
          quotedMessage: replyMessage
            ? {
                parentId: replyMessage.id,
                message:
                  replyMessage.message ||
                  replyMessage.files?.[0]?.url ||
                  "Mensagem citada",
                mime: replyMessage.files?.[0]?.mime
              }
            : undefined
        })
      );
    },
    [onSendMessage, replyMessage, selectedCannedMessageId]
  );

  const handleShortcutSuggestionsScroll = (
    e: React.UIEvent<HTMLDivElement>
  ) => {
    if (!shortcutSuggestionsHasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

    if (scrollHeight - scrollTop <= clientHeight + 10) {
      loadMoreShortcutSuggestions();
    }
  };

  const run = async () => {
    const dialogIdLocal = location?.state?.dialogId || valueDialog;
    if (dialogIdLocal) {
      const dialog = await findDialogHistoryData(dialogIdLocal);
      setValueDialog(dialog);
    }
  };


  const clearPendingAttachments = useCallback(() => {
    setPendingAttachments((prev) => {
      revokeComposerAttachments(prev);
      return [];
    });
  }, []);

  const removePendingAttachment = useCallback(
    (id: string) => {
      if (isSubmittingRef.current) return;

      setPendingAttachments((prev) => {
        const attachmentToRemove = prev.find((attachment) => attachment.id === id);

        if (attachmentToRemove) {
          revokeComposerAttachments([attachmentToRemove]);
        }

        return prev.filter((attachment) => attachment.id !== id);
      });

      focusMessageInput();
    },
    [focusMessageInput]
  );

  const queuePendingAttachments = useCallback(
    (files: FileList | File[] | null) => {
      if (isSubmittingRef.current) return;

      if (!files) return;

      const selectedFiles = Array.isArray(files) ? files : Array.from(files);
      if (!selectedFiles.length) return;
      const validationResult = validateComposerFiles(selectedFiles);

      if (validationResult.errorMessage) {
        toast.current?.show({
          life: 5000,
          severity: "error",
          summary: "Erro.",
          detail: validationResult.errorMessage
        });
        return;
      }

      if (!validationResult.acceptedFiles.length) {
        if (validationResult.partialErrorMessage) {
          toast.current?.show({
            life: 5000,
            severity: "warn",
            summary: "Atenção.",
            detail: validationResult.partialErrorMessage
          });
        }
        return;
      }

      setConcatenatedAudioBlob(undefined);
      setPendingAttachments((prev) => [
        ...prev,
        ...buildComposerAttachments(validationResult.acceptedFiles)
      ]);

      if (validationResult.partialErrorMessage) {
        toast.current?.show({
          life: 5000,
          severity: "warn",
          summary: "Atenção.",
          detail: validationResult.partialErrorMessage
        });
      }

      focusMessageInput();
    },
    [focusMessageInput, toast]
  );

  useEffect(() => {
    const handleComposerFiles = (event: Event) => {
      if (showInput !== "input" && showInput !== "joinContact") {
        return;
      }

      const customEvent = event as CustomEvent<OmnichannelComposerFilesEventDetail>;
      queuePendingAttachments(customEvent.detail?.files ?? []);
    };

    window.addEventListener(
      OMNICHANNEL_COMPOSER_FILES_EVENT,
      handleComposerFiles as EventListener
    );

    return () => {
      window.removeEventListener(
        OMNICHANNEL_COMPOSER_FILES_EVENT,
        handleComposerFiles as EventListener
      );
    };
  }, [queuePendingAttachments, showInput]);

  const sendPendingFilesToCurrentDialog = useCallback(async (text = "") => {
    if (!pendingAttachments.length) return;

    await onFilesAttached(
      createFileListFromFiles(
        pendingAttachments.map((attachment) => attachment.file)
      ),
      text
    );
    clearPendingAttachments();
  }, [clearPendingAttachments, onFilesAttached, pendingAttachments]);

  const resetComposer = useCallback(() => {
    setMessage("");
    resetTextareaHeight();
    clearPendingAttachments();
    setConcatenatedAudioBlob(undefined);
  }, [clearPendingAttachments, resetTextareaHeight]);

  const submitCurrentDialogComposer = useCallback(async () => {
    await withComposerSubmission(async () => {
      const text = message.trim();
      const hasPendingAttachments = pendingAttachments.length > 0;

      if (!text && !hasPendingAttachments) return;
      if (!canSendOnOpenDialog()) return;

      if (hasPendingAttachments) {
        await sendPendingFilesToCurrentDialog(text);
      } else if (text) {
        await sendTextMessage(text);
      }

      dispatch(setReplyMessage(null));
      resetComposer();
      focusMessageInput();
    });
  }, [
    canSendOnOpenDialog,
    dispatch,
    focusMessageInput,
    message,
    pendingAttachments.length,
    resetComposer,
    sendTextMessage,
    sendPendingFilesToCurrentDialog,
    withComposerSubmission
  ]);

  useEffect(() => {
    if (dialog.workspaceTransfer) {
      setShowInput("joinButton");
      return;
    }

    if (!dialog.transferred) {
      setShowInput("joinButton");
      return;
    }

    if (dialog.userTransferredId === user.user.id) {
      setShowInput("input");
      return;
    }

    if (dialog.userTransferredId !== user.user.id) {
      setShowInput("disabledButton");
    }
  }, [updateShowInput, dialog]);

  const joinRoom = async () => {
    if (
      newValueDialogId !== undefined &&
      newValueDialogId !== 0 &&
      newValueDialogId !== user.user.id
    ) {
      toast.current?.show({
        life: 3000,
        severity: "error",
        summary: "Erro.",
        detail:
          "Não é permitido entrar em salas já transferidas, utilize a função de transferência."
      });
      return;
    }
    try {
      if (dialog.workspaceTransfer) {
        await joinQueueDialog(dialog.id);
      } else {
        await joinDialog(dialog.id);
      }
      redirect(
        { pathname: `/omnichannel/` },
        {
          state: {
            dialogId: dialog.id,
            showSidebar: false
          }
        }
      );
      await run();
      await onDialogRefresh?.();
      setShowInput("input");
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any | { message: string }) {
      toast.current?.show({
        life: 3000,
        severity: "error",
        summary: "Erro.",
        detail: error?.message
      });
    }
  };

  const openRoom = async () => {
    try {
      await openDialog(dialog.id);
      redirect(`/omnichannel/`);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any | { message: string }) {
      toast.current?.show({
        life: 3000,
        severity: "error",
        summary: "Erro.",
        detail: error?.message
      });
    }
  };

  useEffect(() => {
    if (contactId !== 0) {
      setShowInput("joinContact");
    }
  }, [contactId]);

  const sendMessageToContact = async () => {
    await withComposerSubmission(async () => {
      const text = message.trim();
      const files = pendingAttachments.map((attachment) => attachment.file);

      if (text.length === 0 && files.length === 0) return;

      if (!botSelected) {
        toast.current?.show({
          life: 3000,
          severity: "warn",
          summary: "Atenção.",
          detail: "Selecione um robô antes de enviar a mensagem."
        });
        return;
      }

      try {
        let lastStatus = 0;
        let lastResponse: any = null;

        for (let index = 0; index < files.length; index += 1) {
          const file = files[index];
          const fileMessage = index === 0 ? text : "";
          const reportProgress = createThrottledProgressReporter((fraction) => {
            setContactFileUploadProgress(
              fraction >= 1 ? null : { index, progress: fraction }
            );
          });

          let uploaded;
          try {
            // eslint-disable-next-line no-await-in-loop
            uploaded = await uploadFileChunked(file, reportProgress);
          } catch (error: any) {
            setContactFileUploadProgress(null);
            toast.current?.show({
              life: 5000,
              severity: "error",
              summary: "Erro.",
              detail:
                error?.message ?? `Não foi possível enviar o arquivo ${file.name}.`
            });
            return;
          }

          setContactFileUploadProgress(null);

          // eslint-disable-next-line no-await-in-loop
          const { status, response } = await startDialogFromContact({
            botId: botSelected,
            contactId,
            userId: user.user.id,
            message: fileMessage,
            file: {
              fileId: uploaded.id,
              name: file.name
            }
          });

          lastStatus = status;
          lastResponse = response;

          if (status !== 200 && status !== 201) {
            toast.current?.show({
              life: 3000,
              severity: "error",
              summary: "Erro.",
              detail: `Falha ao iniciar conversa com arquivo.`
            });
            return;
          }
        }

        if (text.length > 0 && files.length === 0) {
          const { status, response } = await startDialogFromContact({
            botId: botSelected,
            contactId,
            userId: user.user.id,
            message: text
          });

          lastStatus = status;
          lastResponse = response;

          if (status !== 200 && status !== 201) {
            return;
          }
        }

        if (lastStatus === 200 || lastStatus === 201) {
          const dialogId = lastResponse?.dialogId;

          if (dialogId) {
            dispatch(setShowModalContacts(false));
          }
        }

        setShowInput("input");
        dispatch(setContactId(0));
        dispatch(setNameContact(""));
        dispatch(setReplyMessage(null));
        resetComposer();
        focusMessageInput();
      } catch (error: any) {
        toast.current?.show({
          life: 3000,
          severity: "error",
          summary: "Erro.",
          detail:
            error?.message || "Erro ao iniciar conversa a partir do contato."
        });
      }
    });
  };

  useEffect(() => {
    if (contactId === 0 && showInput === "joinContact") {
      setShowInput("input");
      resetComposer();
    }
  }, [contactId, resetComposer, showInput]);

  useEffect(() => {
    if (isSubmitting || !emoji || emojiTarget !== "chat-input") return;

    setMessage((prev) => {
      const text = String(prev ?? "");
      const start = Math.max(0, Math.min(cursorPosition, text.length));

      const first = text.slice(0, start);
      const last = text.slice(start);
      return `${first}${emoji}${last}`;
    });

    dispatch(textEmoji(""));
    dispatch(setEmojiTarget(""));
  }, [cursorPosition, dispatch, emoji, emojiTarget, isSubmitting]);

  useEffect(() => {
    if (replyMessage && messageRef.current) {
      messageRef.current.focus();
    }
  }, [replyMessage]);

  useEffect(() => {
    if (
      showCannedMessageModal ||
      (showInput !== "input" && showInput !== "joinContact")
    ) {
      return;
    }

    focusMessageInput();
  }, [dialog.id, focusMessageInput, showCannedMessageModal, showInput]);

  const quoteKind = (() => {
    const text = (replyMessage?.message ?? "").trim();
    if (text) return "text";

    const mime = replyMessage?.files?.[0]?.mime ?? "";
    if (mime.startsWith("image/")) return "image";
    if (mime.startsWith("audio/")) return "audio";
    if (mime.startsWith("video/")) return "video";
    if (mime) return "other";

    return "text";
  })();

  return (
    <div
      css={css`
        display: flex;
        width: 100%;
        align-items: start;
        padding: 5px 10px 5px 20px;
        margin: 0 20px 20px 20px;
        border-radius: 24px;
        border: 2px solid #cbced1;
        background-color: #ffffff;
        position: relative;
        z-index: 20;
        overflow: visible;
        transition: height 0.2s ease;
        height: auto;
        flex-direction: column;
      `}
    >
      {showCannedMessageModal && (
        <DialogPadrao
          displayDialog={showCannedMessageModal}
          contentStyle={{ height: "600px" }}
          onHide={() => setShowCannedMessageModal(false)}
          headerStyle={{
            backgroundColor: user.user.plataform.mainColor || "#2624CD"
          }}
        >
          <ContainerLeftModal>
            <CannedMessage
              messages={cannedMessages}
              search={cannedMessagesSearch}
              onSearchChange={setCannedMessagesSearch}
              hasMore={cannedMessagesHasMore}
              loading={cannedMessagesLoading}
              onLoadMore={loadMoreCannedMessages}
              onModeChange={setCannedMessageMode}
              onCreateSuccess={handleCreateSuccess}
              onUpdateSuccess={handleUpdateSuccess}
              onDeleteSuccess={handleDeleteSuccess}
            />
          </ContainerLeftModal>

          <ContainerRightModal
            style={{
              backgroundColor: user.user.plataform.mainColor || "#2624CD"
            }}
          >
            <CannedMessageRightModalContent>
              <div className="content">
                <div className="iconWrapper">
                  {user.user.plataform.urlAvatar ? (
                    <img
                      src={user.user.plataform.urlAvatar}
                      style={{ height: "200px", marginTop: "-55px" }}
                    />
                  ) : (
                    <img
                      src={spaikIcon}
                      style={{ height: "200px", marginTop: "-55px" }}
                    />
                  )}
                </div>

                <div className="textGroup">
                  <div className="title">
                    {cannedMessageMode === "list"
                      ? "Escolha uma mensagem"
                      : "Escolha um atalho"}
                  </div>

                  <div className="description">
                    {cannedMessageMode === "list"
                      ? "Selecione uma mensagem da lista para editá-la, ou crie uma nova para que sua equipe possa usá-la digitando um atalho no atendimento."
                      : "Escreva a mensagem que será enviada quando o atalho for usado..."}
                  </div>
                </div>
              </div>
            </CannedMessageRightModalContent>
          </ContainerRightModal>
        </DialogPadrao>
      )}
      {replyMessage && (
        <QuoteMessage $kind={quoteKind}>
          <div className="blueLine" />

          <div className="message">
            <div className="name">
              {replyMessage.isHumanResponder
                ? replyMessage.humanName || user.user.name
                : replyMessage.chatName}
            </div>
            <div className="text">
              {(() => {
                const text = (replyMessage?.message ?? "").trim();

                if (text) return replyMessage.message;

                const replyFiles = (replyMessage as any)?.files ?? [];
                if (!Array.isArray(replyFiles) || replyFiles.length === 0) {
                  return "Mensagem citada não carregada";
                }

                return replyFiles.map((file: iFile, idx: number) => {
                  const mime = file?.mime ?? "";

                  if (mime.startsWith("image/")) {
                    return (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column"
                        }}
                      >
                        <FileImagePreview key={idx} file={file} />
                      </div>
                    );
                  }

                  if (mime.startsWith("audio/")) {
                    return file?.url ? (
                      <AudioPlayer key={idx} url={file.url} />
                    ) : (
                      <div key={idx}>Áudio citado não carregado</div>
                    );
                  }

                  if (mime.startsWith("video/")) {
                    return file?.url ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          maxWidth: "300px"
                        }}
                      >
                        <VideoPreview key={idx} videoURL={file.url} />
                      </div>
                    ) : (
                      <div key={idx}>Vídeo citado não carregado</div>
                    );
                  }

                  return (
                    <FileLinkURL
                      key={idx}
                      filename={file?.fileName ?? "Arquivo"}
                      file={file}
                    />
                  );
                });
              })()}
            </div>
          </div>

          <div className="divButton">
            <Button
              type="button"
              className="pi pi-times"
              style={{
                width: "40px",
                background: "transparent",
                color: "#2624cd"
              }}
              onClick={() => {
                dispatch(setReplyMessage(null));
                focusMessageInput();
              }}
            />
          </div>
        </QuoteMessage>
      )}

      <ComposerAttachmentsPreview
        attachments={pendingAttachments}
        mainColor={user.user.plataform.mainColor || "#2624CD"}
        onRemove={removePendingAttachment}
        disabled={isSubmitting}
        uploadProgress={activeFileUploadProgress}
      />

      {dialog.closedAt === null ? (
        <>
          {showInput === "disabledButton" ? (
            <div className="flex w-full align-items-center justify-content-center">
              <div>
                <Button
                  onClick={joinRoom}
                  disabled={showDisableButton === true}
                >
                  Entrar na Conversa
                </Button>
              </div>
              {dialog.userTransferredId !== user?.user.id && (
                <Tooltip position="mouse" target=".disabled-Message">
                  Esta sala foi transferida para outro atendente. Para entrar na
                  sala novamente, por favor, utilize a opção de transferência de
                  sala.
                </Tooltip>
              )}
            </div>
          ) : null}

          {showInput === "input" ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                position: "relative"
              }}
            >
              {hasShortcutTrigger ? (
                <CannedMessageAutocomplete>
                  <div className="header">
                    <div className="headerLeft">
                      <img src={CannedMessageIcon} alt="Mensagens prontas" />
                      <span>Mensagens prontas</span>
                    </div>

                    <button
                      type="button"
                      className="manageButton"
                      onClick={() => setShowCannedMessageModal(true)}
                    >
                      Gerenciar
                    </button>
                  </div>

                  <div
                    className="suggestionsList"
                    ref={shortcutSuggestionsListRef}
                    onScroll={handleShortcutSuggestionsScroll}
                  >
                    {shortcutSuggestions.length ? (
                      shortcutSuggestions.map((item, index) => (
                        <CannedMessageAutocompleteItem
                          key={item.id}
                          ref={setShortcutSuggestionItemRef(index)}
                          type="button"
                          className={
                            selectedShortcutSuggestionIndex === index
                              ? "selected"
                              : undefined
                          }
                          onMouseEnter={() =>
                            handleShortcutSuggestionMouseEnter(index)
                          }
                          onClick={() => applyCannedMessageShortcut(item)}
                        >
                          <div className="topLine">
                            <div className="shortcut">/{item.shortcut}</div>
                            <div className="title">{item.title}</div>
                          </div>

                          <div className="message">{item.message}</div>
                        </CannedMessageAutocompleteItem>
                      ))
                    ) : (
                      <div className="emptyState">
                        {shortcutSuggestionsLoading
                          ? "Carregando mensagens prontas..."
                          : "Você não possui mensagens prontas."}
                      </div>
                    )}
                  </div>
                </CannedMessageAutocomplete>
              ) : null}

              <button
                type="button"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: "-10px",
                  marginRight: "6px",
                  padding: "0 8px",
                  cursor: isSubmitting ? "not-allowed" : "pointer",
                  opacity: isSubmitting ? 0.5 : 1,
                  border: "none",
                  background: "transparent"
                }}
                onClick={() => {
                  if (isSubmitting) return;
                  setShowCannedMessageModal(true);
                }}
                disabled={isSubmitting}
              >
                <img
                  src={CannedMessageIcon}
                  style={{ width: "20px" }}
                  alt="Canned Message"
                />
              </button>
              {concatenatedAudioBlob === undefined && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    padding: "0",
                    marginRight: "10px"
                  }}
                >
                  <textarea
                    placeholder={`Digite uma mensagem ou "/" para usar uma mensagem pronta...`}
                    css={css`
                      border: none;
                      display: block;
                      font-family: "Poppins";
                      font-size: 14px;
                      line-height: 28px;
                      resize: none;
                      min-height: ${MIN_TEXTAREA_HEIGHT}px;
                      height: ${MIN_TEXTAREA_HEIGHT}px;
                      max-height: 150px;
                      padding: 0;
                      width: 100%;
                      min-width: 0;
                      overflow-y: auto;

                      @media screen and (max-width: 450px) {
                        margin-right: 0;
                      }

                      &::-webkit-scrollbar {
                        width: 8px;
                      }

                      &::-webkit-scrollbar-track {
                        background: transparent;
                      }

                      &::-webkit-scrollbar-thumb {
                        background-color: #c1c1c1;
                        border-radius: 4px;
                      }
                    `}
                    ref={messageRef as React.RefObject<HTMLTextAreaElement>}
                    value={message}
                    disabled={isSubmitting}
                    onChange={(e) => setChatInputMessage(e.target.value)}
                    onKeyUp={(e) =>
                      setCursorPosition(e.currentTarget.selectionStart)
                    }
                    onClick={(e) =>
                      setCursorPosition(e.currentTarget.selectionStart)
                    }
                    onSelect={(e) =>
                      setCursorPosition(e.currentTarget.selectionStart)
                    }
                    onKeyDown={(e) => {
                      if (isSubmitting) {
                        e.preventDefault();
                        return;
                      }

                      if (handleShortcutSuggestionsKeyDown(e)) {
                        e.preventDefault();
                        return;
                      }

                      if (
                        e.key === "Enter" &&
                        !e.shiftKey &&
                        !e.ctrlKey &&
                        (message.trim().length > 0 ||
                          pendingAttachments.length > 0)
                      ) {
                        e.preventDefault();
                        void submitCurrentDialogComposer();
                      }
                    }}
                  />
                </div>
              )}
              <div
                css={css`
                  display: flex;
                  margin-left: auto;
                  gap: 10px;
                  width: ${concatenatedAudioBlob === undefined
                    ? "unset"
                    : "100%"};
                `}
              >
                <ImgIcon
                  className="tooltip-Smile"
                  disabled={isSubmitting}
                  onClick={() => {
                    if (isSubmitting) return;
                    dispatch(setEmojiTarget("chat-input"));
                    dispatch(setEmojiModalOpen(true));
                  }}
                >
                  <img
                    src={Smile}
                    alt="Icon-Smiles"
                    style={{ width: "20px" }}
                  />
                </ImgIcon>
                <AttachFiles
                  disabled={isSubmitting}
                  onChange={(e) => {
                    queuePendingAttachments(e.target.files);
                    e.target.value = "";
                  }}
                />
                {message.trim().length > 0 || pendingAttachments.length > 0 ? (
                  <button
                    type="button"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "2.5rem",
                      padding: "0.5rem",
                      marginLeft: "-7px",
                      border: "none",
                      background: "transparent",
                      opacity: isSubmitting ? 0.5 : 1,
                      cursor: isSubmitting ? "not-allowed" : "pointer"
                    }}
                    onClick={() => void submitCurrentDialogComposer()}
                    disabled={isSubmitting}
                  >
                    <img
                      src={Send}
                      css={css`
                        background-color: #dddddf;
                        border-radius: 50%;
                        padding: 10px;
                        height: 43px;
                        width: 43px;
                      `}
                    />
                  </button>
                ) : (
                  <AudioRecorder
                    disabled={isSubmitting}
                    concatenatedAudioBlob={concatenatedAudioBlob}
                    setConcatenatedAudioBlob={setConcatenatedAudioBlob}
                    onFilesAttached={(files) => {
                      if (!canSendOnOpenDialog()) {
                        return;
                      }
                      onFilesAttached(files);
                    }}
                  />
                )}
              </div>
              {modalEdit && emojiTarget === "chat-input" && (
                <EmojiModal heightEmojiPicker="375px" />
              )}
            </div>
          ) : null}
          {showInput === "joinContact" ? (
            <div
              style={{
                display: "flex",
                width: "100%",
                position: "relative"
              }}
            >
              {hasShortcutTrigger ? (
                <CannedMessageAutocomplete>
                  <div className="header">
                    <div className="headerLeft">
                      <img src={CannedMessageIcon} alt="Mensagens prontas" />
                      <span>Mensagens prontas</span>
                    </div>

                    <button
                      type="button"
                      className="manageButton"
                      onClick={() => setShowCannedMessageModal(true)}
                    >
                      Gerenciar
                    </button>
                  </div>

                  <div
                    className="suggestionsList"
                    ref={shortcutSuggestionsListRef}
                    onScroll={handleShortcutSuggestionsScroll}
                  >
                    {shortcutSuggestions.length ? (
                      shortcutSuggestions.map((item, index) => (
                        <CannedMessageAutocompleteItem
                          key={item.id}
                          ref={setShortcutSuggestionItemRef(index)}
                          type="button"
                          className={
                            selectedShortcutSuggestionIndex === index
                              ? "selected"
                              : undefined
                          }
                          onMouseEnter={() =>
                            handleShortcutSuggestionMouseEnter(index)
                          }
                          onClick={() => applyCannedMessageShortcut(item)}
                        >
                          <div className="topLine">
                            <div className="shortcut">/{item.shortcut}</div>
                            <div className="title">{item.title}</div>
                          </div>

                          <div className="message">{item.message}</div>
                        </CannedMessageAutocompleteItem>
                      ))
                    ) : (
                      <div className="emptyState">
                        {shortcutSuggestionsLoading
                          ? "Carregando mensagens prontas..."
                          : "Você não possui mensagens prontas."}
                      </div>
                    )}
                  </div>
                </CannedMessageAutocomplete>
              ) : null}

              <button
                type="button"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: "-10px",
                  marginRight: "6px",
                  padding: "0 8px",
                  cursor: isSubmitting ? "not-allowed" : "pointer",
                  opacity: isSubmitting ? 0.5 : 1,
                  border: "none",
                  background: "transparent"
                }}
                onClick={() => {
                  if (isSubmitting) return;
                  setShowCannedMessageModal(true);
                }}
                disabled={isSubmitting}
              >
                <img
                  src={CannedMessageIcon}
                  style={{ width: "20px" }}
                  alt="Canned Message"
                />
              </button>
              {concatenatedAudioBlob === undefined && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    padding: "0",
                    marginRight: "10px"
                  }}
                >
                  <textarea
                    placeholder={`Digite uma mensagem ou "/" para usar uma mensagem pronta...`}
                    css={css`
                      border: none;
                      flex: 1;
                      font-family: "Poppins";
                      font-size: 14px;
                      line-height: 28px;
                      resize: none;
                      min-height: ${MIN_TEXTAREA_HEIGHT}px;
                      height: ${MIN_TEXTAREA_HEIGHT}px;
                      max-height: 150px;
                      padding: 0;
                      width: 100%;
                      overflow-y: auto;

                      @media screen and (max-width: 450px) {
                        margin-right: 0;
                      }
                    `}
                    ref={messageRef as React.RefObject<HTMLTextAreaElement>}
                    value={message}
                    disabled={isSubmitting}
                    onChange={(e) => setChatInputMessage(e.target.value)}
                    onKeyUp={(e) =>
                      setCursorPosition(e.currentTarget.selectionStart)
                    }
                    onClick={(e) =>
                      setCursorPosition(e.currentTarget.selectionStart)
                    }
                    onSelect={(e) =>
                      setCursorPosition(e.currentTarget.selectionStart)
                    }
                    onKeyDown={(e) => {
                      if (isSubmitting) {
                        e.preventDefault();
                        return;
                      }

                      if (handleShortcutSuggestionsKeyDown(e)) {
                        e.preventDefault();
                        return;
                      }

                      if (
                        e.key === "Enter" &&
                        !e.shiftKey &&
                        !e.ctrlKey &&
                        (message.trim().length > 0 ||
                          pendingAttachments.length > 0)
                      ) {
                        e.preventDefault();
                        sendMessageToContact();
                      }
                    }}
                  />
                </div>
              )}
              <div
                css={css`
                  display: flex;
                  margin-left: auto;
                  gap: 10px;
                  width: ${concatenatedAudioBlob === undefined
                    ? "unset"
                    : "100%"};
                `}
              >
                <ImgIcon
                  style={{ marginTop: "3px" }}
                  className="tooltip-Smile"
                  disabled={isSubmitting}
                  onClick={() => {
                    if (isSubmitting) return;
                    dispatch(setEmojiTarget("chat-input"));
                    dispatch(setEmojiModalOpen(true));
                  }}
                >
                  <img
                    src={Smile}
                    alt="Icon-Smiles"
                    style={{ width: "20px" }}
                  />
                </ImgIcon>
                <AttachFiles
                  disabled={isSubmitting}
                  onChange={(e) => {
                    queuePendingAttachments(e.target.files);
                    e.target.value = "";
                  }}
                />
                {message.trim().length > 0 || pendingAttachments.length > 0 ? (
                  <button
                    type="button"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "2.5rem",
                      padding: "0.5rem",
                      marginLeft: "-7px",
                      border: "none",
                      background: "transparent",
                      opacity: isSubmitting ? 0.5 : 1,
                      cursor: isSubmitting ? "not-allowed" : "pointer"
                    }}
                    onClick={() => void sendMessageToContact()}
                    disabled={isSubmitting}
                  >
                    <img
                      src={Send}
                      css={css`
                        background-color: #dddddf;
                        border-radius: 50%;
                        padding: 10px;
                        height: 43px;
                        width: 43px;
                      `}
                    />
                  </button>
                ) : (
                  <AudioRecorder
                    disabled={isSubmitting}
                    concatenatedAudioBlob={concatenatedAudioBlob}
                    setConcatenatedAudioBlob={setConcatenatedAudioBlob}
                    onFilesAttached={(files) => {
                      queuePendingAttachments(files);
                    }}
                  />
                )}
              </div>
              {modalEdit && emojiTarget === "chat-input" && (
                <EmojiModal heightEmojiPicker="375px" />
              )}
            </div>
          ) : null}
          {showInput === "joinButton" ? (
            <div className="flex w-full align-items-center justify-content-center">
              <div>
                <Button onClick={joinRoom}>Entrar na Conversa</Button>
              </div>
              {dialog.userTransferredId !== user?.user.id && (
                <Tooltip position="mouse" target=".disabled-Message">
                  Esta sala foi transferida para outro atendente. Para entrar na
                  sala novamente, por favor, utilize a opção de transferência de
                  sala.
                </Tooltip>
              )}
            </div>
          ) : null}
        </>
      ) : (
        <div className="flex w-full align-items-center justify-content-center">
          <div>
            <Button onClick={openRoom}>Abrir Sala</Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Input;
